import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"

export const Section = styled(SectionWrapper)`
  background: #e5f6f2;
  height: 360px;
  overflow: hidden;
  position: relative;
  padding: 0;
  ${({ theme }) => theme.breakpoints.down("md")} {
    height: 300px;
  }
`

export const Wrapper = styled(Container)`
  height: 360px;
  display: flex;
  align-items: end;
  justify-content: flex-start;
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(40)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    height: 300px;
  }
`

export const BackgroundImage = styled(CustomBgImage)`
  /* position: absolute;
  top: 0;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  } */
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(68)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(76)};
  letter-spacing: -0.68px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(44)};
    line-height: ${({ theme }) => theme.typography.pxToRem(52)};
  }
`
